import { React } from 'react';
import '../../styles/components/hero-items/game-main.scss'

const SoulMain = () => (
    <div className="game-banner">
        <div className="game-logo soul">
            <img src="./img/logos/SoulNomad_Logo_Final_small.png" alt="Phantom Brave Logo" />
        </div>
    </div>
)

export default SoulMain;